import Vue from 'vue';
import * as Sentry from '@sentry/vue';

const SENTRY_DSN = process.env.VUE_APP_SENTRY_DSN;

export default function sentry(router) {
  if (!SENTRY_DSN) {
    return;
  }

  Sentry.init({
    Vue,
    dsn: SENTRY_DSN,
    environment: process.env.VUE_APP_MODE,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
    ],
    beforeSend(e, hint) {
      const { response } = hint.originalException;

      if (response && response.status === 404) {
        return null;
      }

      return e;
    },
  });
}
